import React, {PureComponent as Component} from 'react';

import Field from "../../../../ui/template/Form/Field";
import InputText from "../../../../ui/template/Input/InputText";
import Submit from "../../../../ui/template/Form/Submit";
import FormManager from "../../../../ui/template/Form/FormManager";
import Alerts from "../../../../ui/template/Alert/Alerts";
import DropZone from "../../../../ui/template/Drag/DropZone";
import {MCbrowser} from "../../../Context/browserContext";
import memberFileUploadApi from "../../../Controllers/MemberFileUploadApi";
import mosavabatInsertApi from "./Api/insertApi";
import PropTypes from "prop-types";
import TextareaAutosize from "react-textarea-autosize";


class  MosavabatInsert extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.HtitleChange = this.titleChange.bind(this);
        this.HdescriptionChange = this.descriptionChange.bind(this);
        this.HtxtChange = this.txtChange.bind(this);
        this.HnumberChange = this.numberChange.bind(this);

        this.HuploadDelete = this.uploadDelete.bind(this);
        this.HpostUpload = this.postUpload.bind(this);
        this.HreceivedFile = this.receivedFile.bind(this);

        this.handlePostUp = this.postUp.bind(this);
        this.state = {render:true};
        this.values = {  title: '',  number: '',  description:'',txt:""  };

        this.form1=React.createRef();
        this.formAlerts=React.createRef();
        this.props=props;

        this.receivedFiles=[];

        this.dropZone=React.createRef();
    };


    titleChange(e) {
        this.values.title=e.target.value;
        return true;
    };

    numberChange(e) {
        this.values.number=e.target.value;
        return true;
    };

    descriptionChange(e) {
        this.values.description =  e.target.value;
        return true;
    };

    txtChange(e) {
        this.values.txt =  e.target.value;
        return true;
    };

    uploadDelete(obj){
        if(obj.state!=="uploading") {
            this.dropZone.current.deleteItem(obj.id);
            let filtered = this.receivedFiles.filter(function(el) { return el.id != obj.id; });
            this.receivedFiles= filtered;
            this.receivedFileId=-1;
            this.uploadedFileId=-1;
        }
    };

    receivedFile(id){
        let obj = {};
        obj["id"] = id;
        obj["status"] = false;
        obj["uploadedId"] = 0;
        this.receivedFiles.push(obj);
    };

    async postUpload(fileData,fileId) {
        if(this.isAlive) {
            if (this.form1.current.isAlive) this.form1.current.setDisable();
            let pageAlerts = this.context.pageAlerts;
            this.dropZone.current.HchangeStateItem(fileId, "uploading");
            let res = await memberFileUploadApi(fileData, fileId, pageAlerts, this.dropZone.current.HuploadProgress);
            if(this.isAlive) {
                if (res.hasOwnProperty("id")) {
                    let id = res.id;
                    if (id > 0) {
                        this.uploadedFileId=id;
                        this.dropZone.current.HchangeStateItem(fileId,"uploaded",null,null);
                        await this.setUploadId(fileId,id);
                        await this.finishedUpload();
                    }
                }
                //if (this.form1.current.isAlive) this.form1.current.setEnable();
            }
        }
    }

    setUploadId(fileId,id){
        if(this.receivedFiles.length>0){
            for (let i = 0; i < this.receivedFiles.length; i++) {
                if(this.receivedFiles[i].id===fileId){
                    this.receivedFiles[i].uploadedId=id;
                    this.receivedFiles[i].status=true;
                }
            }
        }
    }

    getUnUplodedId() {
        let receivedId=-1;
        if(this.receivedFiles.length>0){
            for (let i = 0; i < this.receivedFiles.length; i++) {
                if(this.receivedFiles[i].status===false){
                    receivedId=this.receivedFiles[i].id;
                    break;
                }
            }
        }
        return  receivedId ;
    }

    getUploadedIdes() {
        let uploadedIdes=[];
        if(this.receivedFiles.length>0){
            for (let i = 0; i < this.receivedFiles.length; i++) {
                if(this.receivedFiles[i].status===true){
                    uploadedIdes.push(this.receivedFiles[i].uploadedId);
                }
            }
        }
        return uploadedIdes;
    }

    async finishedUpload(){
        let receivedId=await this.getUnUplodedId();
        if(receivedId>0){
            await this.dropZone.current.getFileData(this.HpostUpload, receivedId);
        }else{
            let uploadedIdes=await this.getUploadedIdes();
            await this.postingUp(uploadedIdes);
        }
    }

    async postUp() {
        await this.finishedUpload();
    }

    async postingUp(filesTmpId=[]) {
        let pageAlerts = this.context.page.pageAlerts;    
        let l=await mosavabatInsertApi(this.values.number,this.values.title, this.values.description,this.values.txt,filesTmpId,pageAlerts,this.formAlerts);
        if(l===true){
            let page = this.context.page;
            page.dispatcher.run("route","mosavabat","inserted");
        }
    }

    refresh() {
        let r=!this.state.render;
        this.setState({render:r});
    }

    async componentDidMount() { 
         
    } 
    
    render() {

    return (
        <React.Fragment>
            <FormManager ref={this.form1} submit={this.handlePostUp}>
                <div className="js-validate"  >
                    <div className="border rounded bg-white mb-3">
                        <div className="box-title border-bottom p-3">
                            <h6 className="m-0">
                                ثبت مصوبه صورت جلسه
                            </h6>
                            <p className="mb-0 mt-0 small">
                                لطفا
                                اطلاعات خود را صحیح وارد نمائید. ممنون.
                            </p>
                        </div>
                    </div>
                    <div className="box shadow-sm border rounded bg-white mb-3 osahan-share-post">
                        <ul className="nav border-bottom osahan-line-tab" id="myTab" role="tablist">                            
                            <li className="nav-item">
                                <a className="nav-link active" id="profile-tab" data-toggle="tab" href="#mosvInsertTab2"
                                   role="tab" aria-controls="profile" aria-selected="true">
                                    مشخصات مصوبه
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="upload-tab" data-toggle="tab" href="#mosvInsertTab3"
                                   role="tab" aria-controls="profile" aria-selected="false">
                                    بارگزای و آپلود مستندات
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content" id="mosvInsertTabContent">
                            <div className="tab-pane fade show active p-3  " id="mosvInsertTab2" role="tabpanel"  >
                                <div className="row">
                                    <div className="col-12 col-sm-6 col-md-3 mb-4">
                                        <label className="form-label">
                                           شماره
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="number">
                                                <InputText  className="form-control"   onChange={this.HnumberChange}   />
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-9 mb-4">
                                        <label className="form-label">
                                            عنوان
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="title">
                                                <InputText  className="form-control"   onChange={this.HtitleChange}   />
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                                <p>
                                    در اين بخش
                                    موضوع پیشنهادی
                                    و دلیل شکل گیری جلسه و عوامل
                                    به طور كامل بيان ميكنيد.
                                </p>
                                <div className="row">
                                    <div className="col-12 mb-4">
                                        <label className="form-label">
                                           موضوع پیشنهادی
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="description">
                                                <TextareaAutosize    className="form-control  "
                                                                   minRows={7} placeholder="..." onChange={this.HdescriptionChange}  />
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                                <p>
                                    در اين بخش
                                    شرح جلسه با جزئیات
                                    و موصوبات جلسه با جزئیات
                                    به طور كامل بيان ميكنيد.
                                </p>
                                <div className="row">
                                    <div className="col-12 mb-4">
                                        <label className="form-label">
                                            موصوبات جلسه
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="txt">
                                                <TextareaAutosize    className="form-control  "
                                                                     minRows={7} placeholder="..." onChange={this.HtxtChange}  />
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade p-3  " id="mosvInsertTab3" role="tabpanel" >
                                <DropZone openFileStr="بارگزاری تصاویر و فایل ها" ref={this.dropZone} deleteingItem={this.HuploadDelete}
                                          validTypes={["image/gif", "image/jpeg", "image/png", "image/bmp","image/x-icon","image/svg+xml",
                                              "application/x-rar-compressed", "application/octet-stream","application/zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip",
                                              "video/mp4","video/webm","video/ogg","audio/vnd.wave","audio/wave","audio/wav","audio/x-wav","audio/mp3",
                                              "application/pdf","application/octet-streamn","application/msword","application/vnd.ms-powerpoint"
                                          ]}
                                          receivedFile={this.HreceivedFile} isEdit={false} isBtnDirectory={false} isMultiple={true} maxFiles={20} />
                            </div>
                        </div>
                        <div className="row mt-2 mb-2">
                            <div className="col-12 col-sm-6 col-md-5 ">
                                <Alerts layout="relative" ref={this.formAlerts}/>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3 text-right">
                        <button type="reset" className="font-numberjob-bold btn btn-link rounded p-3"  > &nbsp;&nbsp;&nbsp;&nbsp;
                            لغو
                            &nbsp;&nbsp;&nbsp;&nbsp; </button>
                        <Submit className="font-numberjob-bold btn btn-primary rounded p-3"  > &nbsp;&nbsp;&nbsp;&nbsp;
                            ثبت مصوبه
                            &nbsp;&nbsp;&nbsp;&nbsp; </Submit>
                    </div>
                </div>
            </FormManager>
        </React.Fragment>
    )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

MosavabatInsert.contextType = MCbrowser;

MosavabatInsert.propTypes = {
    cat1:PropTypes.string,
    cat2:PropTypes.string,
};

export default MosavabatInsert;
